import React from "react";
import { Oval } from "react-loader-spinner";

const WIDTH__DEFAULT = 32;
const HEIGHT_DEFAULT = 32;

const OvalSpinner = ({
  visible = true,
  color = "#7e7e7e",
  secondaryColor = "#757575",
  width,
  height,
}) => {
  return (
    <Oval
      height={height ?? HEIGHT_DEFAULT}
      width={width ?? WIDTH__DEFAULT}
      radius={9}
      color={color}
      secondaryColor={secondaryColor}
      visible={visible}
    />
  );
};

export default OvalSpinner;
